export default "/_next/static/chunks/fonts/WhitneySSm-Medium-Pro_Web-9c550f324169e3db4fad347e04af4d14.woff2";